module.exports = __webpack_public_path__ + "img/dynamodb.941ded39.png";